import styled from 'styled-components';
import { Grid } from '@elliemae/ds-grid';

var Separator = /*#__PURE__*/styled.div.withConfig({
  componentId: "nx8lwv-0"
})(["width:100%;height:24px;border-right:1px solid ", ";margin:0 8px;"], function (props) {
  return props.theme.colors.neutral['300'];
});
var Title = /*#__PURE__*/styled.h3.withConfig({
  componentId: "nx8lwv-1"
})(["margin:0;font-size:16px;min-height:20px;font-weight:", ";color:", ";"], function (props) {
  return props.theme.fontWeights.semibold;
}, function (props) {
  return props.theme.colors.neutral['700'];
});
var Description = /*#__PURE__*/styled.p.withConfig({
  componentId: "nx8lwv-2"
})(["margin:0;font-size:12px;min-height:18px;display:flex;align-items:center;color:", ";"], function (props) {
  return props.descriptionColor === 'neutral' ? props.theme.colors.neutral['600'] : props.theme.colors.brand['600'];
});
var RightAddon = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "nx8lwv-3"
})(["margin:0;white-space:nowrap;"]);
var RightDescription = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "nx8lwv-4"
})(["margin:0;white-space:nowrap;font-size:12px;color:", ";"], function (props) {
  return props.theme.colors.neutral['600'];
});
var RightValue = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "nx8lwv-5"
})(["margin:0;white-space:nowrap;font-size:14px;color:", ";"], function (props) {
  return props.theme.colors.neutral['800'];
});
var ExpandContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "nx8lwv-6"
})(["font-size:12px;"]);

var border = function border(_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.colors.brand['600'] : theme.colors.neutral['200'];
};

var background = function background(_ref2) {
  var active = _ref2.active,
      theme = _ref2.theme;
  return active ? theme.colors.brand['100'] : theme.colors.neutral['000'];
};

var Container = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "nx8lwv-7"
})(["width:100%;min-height:52px;min-width:244px;padding:6px 8px 6px 12px;position:relative;border-top:1px solid ", ";border-bottom:1px solid ", ";background:", ";", " &:hover{box-shadow:0 2px 4px 0 rgba(53,60,70,0.5);z-index:1;}& + ", "{border-top-color:blue;}"], border, border, background, function (props) {
  return props.disabled ? "\n    ".concat(Title, ", ").concat(Description, ", ").concat(RightDescription, ", ").concat(RightValue, " {\n      color: ").concat(props.theme.colors.neutral['500'], ";\n    }\n  ") : '';
}, Container);

export { Container, Description, ExpandContent, RightAddon, RightDescription, RightValue, Separator, Title };
//# sourceMappingURL=styled.js.map
